"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useNextStepNavigation = useNextStepNavigation;
var _contexts = require("../contexts");
function useNextStepNavigation() {
    const { wasNavigationToNextStep } = (0, _contexts.useNextStepNavigationContext)();
    const setWasNavigationToNextStep = (value)=>{
        if (wasNavigationToNextStep) {
            wasNavigationToNextStep.current = value;
        }
    };
    var _wasNavigationToNextStep_current;
    return {
        setWasNavigationToNextStep,
        wasNavigationToNextStep: (_wasNavigationToNextStep_current = wasNavigationToNextStep === null || wasNavigationToNextStep === void 0 ? void 0 : wasNavigationToNextStep.current) !== null && _wasNavigationToNextStep_current !== void 0 ? _wasNavigationToNextStep_current : false
    };
}
